module.exports = __webpack_public_path__ + "img/LOGO.69ef7288.png";